export let GLOBAL = {
  // url: 'http://localhost:17678/',
  url: 'https://api-mayoristas-crhpchacftfkaucx.eastus-01.azurewebsites.net/',
};
